import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appAnnounceTooltip]'
})
export class AnnounceTooltipDirective {
  @Input('appAnnounceTooltip') text: string = '';

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
  ) { }

  @HostListener('mouseenter', ['$event']) announceSortChange() {
			this._liveAnnouncer.announce(this.text);
	}

}
